module.exports = __webpack_public_path__ + "static/s5-3-losing-d-4c92f89252b80a96bc9d4bd5adc37d88.jpg";